"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _hopsSdkJs = require("@hps/hops-sdk-js");
var _moment = _interopRequireDefault(require("moment/moment"));
var _CheckoutDeliveryMethodCard = _interopRequireDefault(require("./CheckoutDeliveryMethodCard"));
var _Flex = _interopRequireDefault(require("../Components/Flex"));
var _String = _interopRequireDefault(require("../Components/String"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Checkout delivery method section
 * 
 * @package HOPS
 * @subpackage Checkout
 * @copyright Heritage Operations Processing Limited
 */const CheckoutDeliveryMethods = ({
  BasketItems,
  DeliveryMethodInstances,
  disabled,
  onChangeDeliveryMethod,
  showDescription
}) => {
  /**
   * Render the delivery methods.
   */
  const renderDeliveryMethods = () => {
    let hasFilteredDeliveryMethods = false;
    const ticketsTravel = BasketItems.filter(i => i.OrderableType === _hopsSdkJs.OrderableTypes.TicketTravel);
    const ticketsSession = BasketItems.filter(i => i.OrderableType === _hopsSdkJs.OrderableTypes.TicketSession);
    const vouchers = BasketItems.filter(i => i.OrderableType === _hopsSdkJs.OrderableTypes.VoucherSale);
    const giftCards = BasketItems.filter(i => i.OrderableType === _hopsSdkJs.OrderableTypes.GiftCardInventory);
    const railwayProductsWithDelivery = []; // this.props.basket.filter(t => t.OrderableType === OrderableTypes.RailwayProduct && DeliveryMethodUtils.doesBasketItemRequireDelivery(t));

    let ticketsTravelDeliveryMethods = DeliveryMethodInstances.filter(x => x.Orderables?.Travel?.Enabled === true);
    const vouchersDeliveryMethods = DeliveryMethodInstances.filter(x => x.Orderables?.Vouchers?.Enabled === true);
    const giftCardDeliveryMethods = DeliveryMethodInstances.filter(x => x.Orderables?.GiftCards?.Enabled === true);
    const railwayProductDeliveryMethods = DeliveryMethodInstances.filter(x => x.Orderables?.Products?.Enabled === true);

    // If there are any Ticket Travel items in the basket where travel date is within 7 days remove any Delivery Methods which require a delivery address
    if (ticketsTravel.filter(item => item.OrderableType === _hopsSdkJs.OrderableTypes.TicketTravel).some(t => (0, _moment.default)().add(7, "d") >= (0, _moment.default)(t.Item?.Date))) {
      hasFilteredDeliveryMethods = true;
      ticketsTravelDeliveryMethods = ticketsTravelDeliveryMethods.filter(d => d.RequiresDeliveryAddress === false);
    }
    const ticketsTravelCurrentSelection = ticketsTravelDeliveryMethods?.find(i => i.Id === BasketItems?.find(i => i.Uuid === ticketsTravel[0]?.DeliveryMethodItemUuid)?.Item?.Id);
    const vouchersCurrentSelection = vouchersDeliveryMethods?.find(i => i.Id === BasketItems?.find(i => i.Uuid === vouchers[0]?.DeliveryMethodItemUuid)?.Item?.Id);
    const giftCardsCurrentSelection = giftCardDeliveryMethods?.find(i => i.Id === BasketItems?.find(i => i.Uuid === giftCards[0]?.DeliveryMethodItemUuid)?.Item?.Id);
    const railwayProductCurrentSelection = railwayProductDeliveryMethods?.find(i => i.Id === BasketItems?.find(i => i.Uuid === railwayProductsWithDelivery[0]?.DeliveryMethodItemUuid)?.Item?.Id);
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [ticketsTravel.length > 0 &&
      /*#__PURE__*/
      // Once for ALL OrderableTypes.TicketTravel
      (0, _jsxRuntime.jsx)(_CheckoutDeliveryMethodCard.default, {
        eligibleItems: ticketsTravel,
        caption: "For all travel tickets.",
        deliveryMethodCheckoutStrings: vouchersDeliveryMethods.map(d => ({
          DeliveryMethod: d.Id,
          CheckoutText: d.Orderables.Travel?.CheckoutText
        })),
        deliveryMethods: ticketsTravelDeliveryMethods,
        disabled: disabled,
        initialSelection: ticketsTravelCurrentSelection,
        label: "Travel Ticket(s)",
        onChange: onChangeDeliveryMethod,
        showDescription: showDescription
      }), ticketsSession.map((session, key) => {
        // Once for EACH OrderableTypes.TicketSession

        let ticketsSessionDeliveryMethods = DeliveryMethodInstances.filter(deliveryMethodInstance => session.Item?.Session?.Product?.DeliveryMethods.map(deliveryMethod => deliveryMethod.Id).includes(deliveryMethodInstance.Id));

        // If the session start date is within 7 days remove HOPS Post, HOPS Post Gift Pack and Railway Post options
        if ((0, _moment.default)().add(7, "d") >= (0, _moment.default)(session.Item?.Session?.StartDate)) {
          hasFilteredDeliveryMethods = true;
          ticketsSessionDeliveryMethods = ticketsSessionDeliveryMethods.filter(d => !(d.Id === _hopsSdkJs.DeliveryMethods.values.PostByHOPS) && !(d.Id === _hopsSdkJs.DeliveryMethods.values.PostByHOPSGiftPack) && !(d.Id === _hopsSdkJs.DeliveryMethods.values.PostByRailway));
        }
        const ticketsSessionCurrentSelection = ticketsSessionDeliveryMethods?.find(i => i.Id === BasketItems?.find(i => i.Uuid === session?.DeliveryMethodItemUuid)?.Item?.Id);
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CheckoutDeliveryMethodCard.default, {
          eligibleItems: [session],
          caption: _hopsSdkJs.CheckoutBasketItem.getUiSubtext(session),
          deliveryMethodCheckoutStrings: ticketsSessionDeliveryMethods.map(d => ({
            DeliveryMethod: d.Id,
            CheckoutText: d.Orderables.Events?.CheckoutText
          })),
          deliveryMethods: ticketsSessionDeliveryMethods,
          disabled: disabled,
          initialSelection: ticketsSessionCurrentSelection,
          label: _hopsSdkJs.CheckoutBasketItem.getUiLabel(session),
          onChange: onChangeDeliveryMethod,
          showDescription: showDescription
        }, key);
      }), vouchers.length > 0 &&
      /*#__PURE__*/
      // Once for ALL OrderableTypes.VoucherSale
      (0, _jsxRuntime.jsx)(_CheckoutDeliveryMethodCard.default, {
        eligibleItems: vouchers,
        caption: "For all Voucher(s).",
        deliveryMethodCheckoutStrings: vouchersDeliveryMethods.map(d => ({
          DeliveryMethod: d.Id,
          CheckoutText: d.Orderables.Vouchers?.CheckoutText
        })),
        deliveryMethods: vouchersDeliveryMethods,
        disabled: disabled,
        initialSelection: vouchersCurrentSelection,
        label: "Voucher(s)",
        onChange: onChangeDeliveryMethod,
        showDescription: showDescription
      }), giftCards.length > 0 &&
      /*#__PURE__*/
      // Once for ALL OrderableTypes.GiftCardInventory
      (0, _jsxRuntime.jsx)(_CheckoutDeliveryMethodCard.default, {
        eligibleItems: giftCards,
        caption: "For all Gift Card(s).",
        deliveryMethodCheckoutStrings: vouchersDeliveryMethods.map(d => ({
          DeliveryMethod: d.Id,
          CheckoutText: d.Orderables.GiftCards?.CheckoutText
        })),
        deliveryMethods: giftCardDeliveryMethods,
        disabled: disabled,
        initialSelection: giftCardsCurrentSelection,
        label: "Gift Card(s)",
        onChange: onChangeDeliveryMethod,
        showDescription: showDescription
      }), railwayProductsWithDelivery.length > 0 &&
      /*#__PURE__*/
      // Once for ALL OrderableTypes.RailwayProduct
      (0, _jsxRuntime.jsx)(_CheckoutDeliveryMethodCard.default, {
        eligibleItems: railwayProductsWithDelivery,
        caption: "For all shop products.",
        deliveryMethodCheckoutStrings: vouchersDeliveryMethods.map(d => ({
          DeliveryMethod: d.Id,
          CheckoutText: d.Orderables.Products?.CheckoutText
        })),
        deliveryMethods: railwayProductDeliveryMethods,
        disabled: disabled,
        initialSelection: railwayProductCurrentSelection,
        label: "Shop Products",
        onChange: onChangeDeliveryMethod,
        showDescription: showDescription
      }), hasFilteredDeliveryMethods && renderPostalRestrictionWarning()]
    });
  };

  /**
   * Render a warning if there are items in the basket with restrictions on posting.
   */
  const renderPostalRestrictionWarning = () => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
      color: "error",
      str: "Some items can't be posted because the tickets might not arrive before the event.",
      variant: "body2"
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
    fullWidth: true,
    gap: 3,
    children: renderDeliveryMethods()
  });
};
var _default = exports.default = CheckoutDeliveryMethods;